// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3m-S1","col":"styles_col__3pTvi"};